import { render, staticRenderFns } from "./AffiliationsList.vue?vue&type=template&id=3fe1a1a2&"
import script from "./AffiliationsList.vue?vue&type=script&lang=js&"
export * from "./AffiliationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports